import { CardSize } from '@bingads-webui-campaign-react/overview-card-const';
import {
  AssetPerformanceCardWithAssetData as AssetPerformanceCard,
  AssetPerformanceFilterWithAssetGroupsData as AssetPerformanceFilter,
} from '@bingads-webui-campaign-react/asset-performance-card';
import { TopLocationsCard, TopLocationViewSelector } from '@bingads-webui-campaign-react/top-locations-card';
import { PerformanceCardContainer } from '@bingads-webui-campaign/fluent-page-view-constructor';
import { OverviewDiagnosticCard } from '@bingads-webui-campaign/overview-diagnostic-card';
import { cardTopLocationsId } from '@bingads-webui-campaign/fluent-page-consts';


const diagnosticId = 'Diagnostic';
export const assetPerfId = 'AssetPerf';
export const getDefaultCardState = (i18n) => {
  const defaultCardState = [{
    id: 'fluent-react-performance-card',
    name: i18n.getString(_TL_('Performance')),
    size: CardSize.FullScreen,
    isResizable: false,
    reactView: PerformanceCardContainer,
    isInViewportOnPageLoad: true,
  },
  {
    id: diagnosticId,
    name: i18n.getString(_TL_('Diagnostic')),
    size: CardSize.FullScreen,
    isResizable: false,
    reactView: OverviewDiagnosticCard,
    isInViewportOnPageLoad: true,
  },
  {
    id: cardTopLocationsId,
    name: i18n.getString(_TL_('Top locations')),
    size: CardSize.Small,
    isResizable: false,
    reactView: TopLocationsCard,
    CardHeaderContent: TopLocationViewSelector,
  },
  {
    id: assetPerfId,
    name: i18n.getString(_TL_('Asset Performance')),
    size: CardSize.Small,
    isResizable: false,
    reactView: AssetPerformanceCard,
    CardHeaderContent: AssetPerformanceFilter,
  },
  ];
  return defaultCardState;
};
